<template>
    <div class="form-content-wrapper mb-0">
        <b-form-group label="Foto Pendukung">
            <div class="row-3" v-if="dataFotoPendukung.activeFotoPendukungBase64 != null"
                v-for="item of dataFotoPendukung.activeFotoPendukungBase64" :key="item.id">
                <b-row no-gutters>
                    <b-col cols="5" class="mx-2">
                        <div class="foto-preview-wrapper my-2">
                            <div class="foto-content-wrapper">
                                <img :src="$baseFilePath + item.name" alt="Foto Identitas">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview($baseFilePath + item.name)">View</b-button>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="-1">
                        <b-button class="btn btn-danger btn-sm" @click="removeFoto(item)">X</b-button>
                    </b-col>
                </b-row>
            </div>
            <div class="foto-input-wrapper">

                <div class="foto-action-wrapper">
                    <div class="action-browse-wrapper">
                        <b-form-file v-model="dataFotoPendukung.fotoPendukung" name="fotoPendukung"
                            :state="Boolean(dataFotoPendukung.fotoPendukung)" placeholder="Foto Identitas"
                            drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg"
                            @input="browseFile()"></b-form-file>
                        <b-button variant="cancelBtn">
                            <i class="fa fa-upload mr-2"></i>
                            Upload
                        </b-button>
                    </div>
                    <div class="action-camera-wrapper cameraSmallWrapper">
                        <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto()">
                            <i class="fa fa-camera mr-2"></i>
                            Camera
                        </b-button>
                    </div>
                    <div class="action-reset-wrapper"
                        v-if="dataFotoPendukung.urlFotoPendukung != null && dataFotoPendukung.activeFotoPendukungBase64 != $baseFilePath + dataFotoPendukung.urlFotoPendukung">
                        <b-button variant="cancelBtn" @click="resetFoto()">
                            <i class="fa fa-undo mr-2"></i>
                            Reset
                        </b-button>
                    </div>
                </div>
            </div>
        </b-form-group>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>
        <ModalWebCam @photoTaken="setResult" />
        <ModalPreview :fotoPreview="activeFotoPreview" />

        <ModalConfirm id="modal-conf-hapus" title="Confirm Hapus Foto" desc="Apakah anda yakin untuk menghapus Foto ini?"
            @submit="onHapusFoto" />

    </div>
</template>

<script>
import ModalWebCam from '@/components/webcam/ModalWebCam'
import ModalPreview from '@/components/webcam/ModalPreview'

export default {
    name: 'data-foto',
    components: {
        ModalWebCam,
        ModalPreview
    },
    data() {
        return {
            activeFotoPreview: "",
            activeFotoId: "",
        }
    },
    props: {
        id: { type: Number, required: true },
        dataFotoPendukung: { type: Object, required: true },
    },
    methods: {

        ambilFoto() {
            this.$bvModal.show("modal-ambil-foto");
        },

        async setResult(result) {
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            if (this.dataFotoPendukung.activeFotoPendukungBase64 == null) {
                this.dataFotoPendukung.activeFotoPendukungBase64 = []
            }
            this.dataFotoPendukung.activeFotoPendukungBase64.push(newResult)
        },

        resetFoto() {
            this.dataFotoPendukung.activeFotoPendukungBase64 = this.$baseFilePath + this.dataFotoPendukung.urlFotoPendukung
        },

        browseFile() {
            this.$bvModal.show("modal-loading")
            let formData = new FormData()
            formData.append('id', this.id);
            formData.append('file', this.dataFotoPendukung.fotoPendukung);

            this.$axios.post(`cap-emas/insert-photo/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.$helper.toastSucc(this, "Foto berhasil diubah!")

                this.$emit('fetchFoto')
                this.$bvModal.hide("modal-loading")
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.$helper.toastErr(this, error.response.data.reason)
                this.$bvModal.hide("modal-loading")
            });
        },

        removeFoto(item) {
            this.activeFotoId = item.id
            this.$bvModal.show("modal-conf-hapus")
        },

        onHapusFoto() {
            this.$bvModal.show("modal-loading")
            this.$axios.post(`/cap-emas/delete-photo?photoId=${this.activeFotoId}`).then(() => {
                this.$helper.toastSucc(this, "Foto berhasil dihapus!")
                this.$emit('fetchFoto')
                this.$bvModal.hide("modal-loading")
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.$helper.toastErr(this, error.response.data.reason)
                this.$bvModal.hide("modal-loading")
            });
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        openModalPreview(item) {
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        }

    }
}
</script>
